import { spaceGQLFields } from '../space/space.fields.js';
import { actionPermissionGQLFields, } from './actionPermissions.fields.js';
const BASIC_POST_TYPE_AUTH_MEMBER_PROPS_FIELDS = {};
const ALL_POST_TYPE_AUTH_MEMBER_PROPS_FIELDS = {
    permissions: 'basic',
};
export function postTypeAuthMemberPropsGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_POST_TYPE_AUTH_MEMBER_PROPS_FIELDS;
    if (fields === 'all')
        fields = ALL_POST_TYPE_AUTH_MEMBER_PROPS_FIELDS;
    return `
    context
    scopes
    ${fields.permissions
        ? `
      permissions {
        ${actionPermissionGQLFields(fields.permissions)}
      }
    `
        : ``}
    ${fields.availableSpaces
        ? `
      availableSpaces {
        ${spaceGQLFields(fields.availableSpaces)}
      }
    `
        : ``}    
  `;
}
//# sourceMappingURL=postTypeAuthMemberProps.fields.js.map